import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { NextButton } from '../../common/elements/NextButton';
import { Loading } from '../../common/blocks/Loading';
import { TextInput } from '../../common/elements/TextInput';
import { Validation } from '../../../utils/validation';
import {
	actionCreators as transactionActions,
	isSendingReceipt,
} from '../../../reducer/transaction';
import {
	getCurrentTraveller,
} from '../../../reducer/traveller';
import {
	ChevronDownIcon,
	ChevronUpIcon,
} from './HistoryContainer';

class SendReceipt extends Component {
	state = {
		receiptEmail: this.props.traveller.receiptEmail,
		isReceiptFormExpanded: false,
		isInvalidReceiptEmail: false,
		isReceiptSent: false,
	};

	expandReceiptForm = () => {
		this.setState(state => ({
			isReceiptFormExpanded: !state.isReceiptFormExpanded,
			isReceiptSent: false,
		}));
	}

	onChangeReceiptEmail = (target) => {
		const email = target.value;
		let isInvalidReceiptEmail = false;

		if (!Validation.email.test(email)) {
			isInvalidReceiptEmail = true;
		}

		this.setState({
			receiptEmail: email,
			isInvalidReceiptEmail,
		});
	}

	sendTransactionReceipt = async () => {
		const { receiptEmail } = this.state;
		const { transaction, sendReceipt } = this.props;

		if (!Validation.email.test(receiptEmail)) {
			this.setState({ isInvalidReceiptEmail: true });

			return;
		}

		this.setState({ isReceiptFormExpanded: false });

		await sendReceipt(transaction.id, receiptEmail);

		this.setState({ isReceiptSent: true });
	}

	render() {
		const {
			receiptEmail,
			isInvalidReceiptEmail,
			isReceiptFormExpanded,
			isReceiptSent,
		} = this.state;

		const {
			isSendingReceipt,
		} = this.props;

		return (
			<>
				<ReceiptFormToggleButton onClick={this.expandReceiptForm} aria-expanded={isReceiptFormExpanded}>
					{isReceiptFormExpanded ? (
						<p>
							<ChevronUpIcon
								className="svg-icon"
								aria-hidden="true"
								focusable="true"
								alt=""
							/>
						</p>
					) : (
						<>
							<p>Skicka kvitto</p>
							<p>
								<ChevronDownIcon
									className="svg-icon"
									aria-hidden="true"
									focusable="true"
									alt=""
								/>
							</p>
						</>
					)}
				</ReceiptFormToggleButton>

				{isSendingReceipt && <Loading text="Skickar..." />}

				{isReceiptSent && !isReceiptFormExpanded && <ReceiptSent>Kvitto har skickats!</ReceiptSent>}

				{isReceiptFormExpanded && (
					<ReceiptFormWrapper>
						<ReceiptEmailWrapper>
							<ReceiptEmailInput
								type="text"
								handleChange={this.onChangeReceiptEmail}
								value={receiptEmail || ''}
								placeholder="Ange e-post som du vill skicka kvittot till"
								isError={isInvalidReceiptEmail}
								errorMessage="Fel format på e-postadressen"
								autoComplete="email"
								id="receiptEmail"
							/>
						</ReceiptEmailWrapper>

						<ReceiptFormButton onClick={this.sendTransactionReceipt} disabled={isSendingReceipt}>
							Skicka
						</ReceiptFormButton>
					</ReceiptFormWrapper>
				)}
			</>
		);
	}
}

const ReceiptFormToggleButton = styled.button`
	background: none;
	border: none;
	margin: 15px auto 0;
	display: block;
	font-family: ${props => props.theme.text};
	font-size: 12px;
	font-weight: 600;
	line-height: 17px;
	p {
		margin: 0;
	}
`;

const ReceiptSent = styled.strong`
	display: block;
	text-align: center;
	width: 100%;
	margin-top: 1rem;
	margin-bottom: 1rem;
	font-size: 16px;
`;

const ReceiptFormWrapper = styled.div`
	display: flex;
	gap: 1rem;
	margin-top: 2rem;
`;

const ReceiptEmailWrapper = styled.div`
	width: 100%;
`;

const ReceiptEmailInput = styled(TextInput)`
	min-width: 55px;
	font-size: 14px;
	margin-bottom: 0;
`;

const ReceiptFormButton = styled(NextButton)`
	margin-bottom: 3rem;
`;

export default connect(
	store => ({
		traveller: getCurrentTraveller(store.traveller),
		isSendingReceipt: isSendingReceipt(store),
	}),
	{
		...transactionActions,
	}
)(SendReceipt);
